import Image from 'next/image'
import { useEffect, useRef, useState } from 'react'
import styles from './WhatsappChallanNewFlow.module.scss'
import {
  collapseImageSrc,
  expandImageSrc,
  minChallanListHeight,
  noChallanDoneIcon,
  noChallanText,
  previewTextCollapsed,
  previewTextExpanded,
} from './constants'
import { IChallanListProps } from './interfaces'
import ChallanListItem from './ChallanItem'

const NoChallans = () => (
  <div className={styles.emptyChallan}>
    <Image src={noChallanDoneIcon} alt="No Challans" width={64} height={64} className={styles.emptyChallanImage} />
    <span className={styles.emptyChallanText}>{noChallanText}</span>
  </div>
)

const ChallanList = ({ challans, isNonVahanState }: IChallanListProps) => {
  const [expanded, setExpanded] = useState(false)
  const chllanListLength = challans?.length || 0
  const [height, setHeight] = useState(minChallanListHeight)
  const contentRef = useRef<HTMLDivElement | null>(null)

  const updateHeight = () => {
    const el = contentRef.current
    if (!el) return

    const contentHeight = el.scrollHeight

    if (expanded) {
      setHeight(`${contentHeight}px`)
    } else {
      setHeight(`${contentHeight}px`)
      requestAnimationFrame(() => {
        setHeight(minChallanListHeight)
      })
    }
  }

  useEffect(() => {
    updateHeight()
  }, [expanded])

  if (isNonVahanState) return null

  const hasExtraChallans = chllanListLength > 2
  return (
    <div className={styles.challanList}>
      {chllanListLength === 0 ? (
        <NoChallans />
      ) : (
        <>
          <div className={styles.listContainer} ref={contentRef} style={{ maxHeight: height }}>
            {challans?.map((challan, idx) => <ChallanListItem challan={challan} key={idx} />)}
          </div>
          {hasExtraChallans && (
            <div
              className={`${styles.blurSegment} ${expanded ? styles.expanded : ''}`}
              onClick={() => setExpanded(prev => !prev)}>
              <div className={styles.previewText}>{!expanded ? previewTextCollapsed : previewTextExpanded}</div>
              <Image
                src={expanded ? collapseImageSrc : expandImageSrc}
                alt="Expand/Collapse Icon"
                width={20}
                height={20}
                className={styles.expandIcon}
              />
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default ChallanList
